// Chat-completion rows ({role, content, tool_calls?}) as SidePaneChat rows.
//
// Ids are the row's index, which is stable because these conversations only
// ever grow at the end or are reset whole. Tool rows are protocol, not
// conversation, and are dropped. Nothing else is hidden here: the hooks
// already decide which rows a pane shows (slice(2), visibleMessages), and a
// second filter would drift from theirs.
import type React from 'react'
import type { SidePaneMessage } from '../../agent'
import type { ChatMessage } from './types'

export type RenderChatMessage = (message: ChatMessage, index: number) => React.ReactNode | undefined

/**
 * `renderMessage` is a host's own drawing for a row (the Tables pane's
 * render_graph charts, chat/utils.tsx renderChatMessage). Its result follows
 * the ChatSession contract: undefined draws the row as usual, null hides the
 * row, and a node is drawn under the row's text as its `extra`.
 */
export function toSidePaneMessages(messages: ChatMessage[], renderMessage?: RenderChatMessage): SidePaneMessage[] {
  const out: SidePaneMessage[] = []
  messages.forEach((m, i) => {
    if (m.role !== 'user' && m.role !== 'assistant' && m.role !== 'system') return
    const custom = renderMessage?.(m, i)
    if (custom === null) return
    out.push({
      id: String(i),
      role: m.role,
      content: typeof m.content === 'string' ? m.content : '',
      ...(custom !== undefined ? { extra: custom } : {}),
    })
  })
  return out
}
